import request from '@/router/axios'

export function getPage(query) {
    return request({
        url: '/chain/projectattendance/getAttendanceList',
        method: 'get',
        params: query
    })
}
